<div class="text-center mt-5">
    Debug Bar <br>
    <button type="button" class="btn mx-1 btn-danger" (click)="createFakePatients()">Add patients</button>
    <button type="button" class="btn mx-1 btn-danger" (click)="deleteAllPatients()">Del patients</button>
    <button type="button" class="btn mx-1 btn-danger" (click)="createFakeDevices()">Add devices</button>
    <button type="button" class="btn mx-1 btn-danger" (click)="deleteAllDevices()">Del devices</button>

</div>